import axios from "axios";
import environment from "@/environment";

const api = axios.create({ baseURL: `${environment.API}/spreadsheet` });


export const spreadsheetService = {
	checkSpreadsheetStatus: () => api.get("/dailyCheck")

};

export async function FetchSpreadsheetDashboard () {
	try {
		const response = await spreadsheetService.checkSpreadsheetStatus();

		return { ...response.data, statusCode: response.status };
	}
	catch (error) {
		if (error.response) {
			return {
				statusCode: error.response.status,
				message: error.response.data.message,
				...error.response.data
			};
		}

		return { statusCode: 500, message: "Falha crítica de conexão" };
	}

}


